var map = {
	"./Administrativo.png": 146,
	"./CheckList.png": 8208,
	"./Licitaciones.png": 8329,
	"./Mecanismos.png": 7745,
	"./Publico.png": 5048,
	"./Responsabilidad.png": 7857
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5854;